import axios from 'axios';

export const acquirePushSaleItem = async (token) => {
  const res = await axios.post(`/push-sales`, { token: decodeURIComponent(token) })
  return res
}
